import React, { useState } from "react";
import CrudModalList from "./CrudModalList";
import { deleteCompanyAddresses, saveCompanyAddresses } from "../../../../../services/empresa";
import GenericModal from "../../../../../components/GenericModal";
import helper from "../../../../../utils/helper";

const Addresses = ({ enderecos = [], userInfo, fetchCompany }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const handleSave = async (payload) => {
        await saveCompanyAddresses(userInfo.empresa, payload).then((res) => {
            if ((res.status === 200 || res.status === 201) && fetchCompany) {
                fetchCompany();
                helper.dispatchEvent("showAviso", {
                    message: "Endereço salvo com sucesso!"
                })
            }
        });
    };

    const openDeleteModal = (id) => {
        setSelectedId(id);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setSelectedId(null);
        setShowDeleteModal(false);
    };

    const confirmDelete = async () => {
        if (!selectedId) return;

        deleteCompanyAddresses(userInfo.empresa, selectedId).then(() => {
            if (fetchCompany) {
                fetchCompany();
                helper.dispatchEvent("showAviso", {
                    message: "Endereço excluído com sucesso!"
                })
            }
        });

        closeDeleteModal();
    };

    return (
        <>
            <CrudModalList
                title="Endereço"
                data={enderecos}
                initialState={{
                    descricao: "",
                    endereco: "",
                    bairro: "",
                    municipio: "",
                    estado: "",
                    cep: ""
                }}
                fields={[
                    { id: "descricao", label: "Descrição", col: "col-md-12" },
                    { id: "endereco", label: "Endereço", col: "col-md-8" },
                    { id: "bairro", label: "Bairro", col: "col-md-4" },
                    { id: "municipio", label: "Município", col: "col-md-6" },
                    { id: "estado", label: "Estado", col: "col-md-4" },
                    { id: "cep", label: "CEP", col: "col-md-2" }
                ]}
                columns={[
                    { key: "descricao", label: "Descrição" },
                    { key: "endereco", label: "Endereço" }
                ]}
                onSave={handleSave}
                onDelete={(id) => openDeleteModal(id)}
            />

            <GenericModal
                isOpen={showDeleteModal}
                title="Deletar Endereço"
                description="Tem certeza que deseja deletar esse endereço?"
                onConfirm={confirmDelete}
                onClose={closeDeleteModal}
                isDelete={true}
            />
        </>
    );
};

export default Addresses;